import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { LoadPanelService } from '../services/load-panel.service';
import { catchError, finalize } from 'rxjs/operators';
import { NotificationService } from '../services/notification.service';

@Injectable({
  providedIn: 'root'
})
export class LoadingInterceptor implements HttpInterceptor {

  private timer;
  private requestCount = 0;

  constructor(private loadPanelService: LoadPanelService,
              private notificationService: NotificationService) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.url.startsWith('http')) {
      this.requestCount++;
      this.timer = setTimeout(() => {
        if (this.requestCount > 0) {
          this.loadPanelService.setLoadPanelVisibility(true);
        }
      }, 500);
    }
    return next.handle(request).pipe(finalize(() => {
      if (request.url.startsWith('http')) {
        if (this.timer) {
          clearTimeout(this.timer);
        }
        if (this.requestCount > 0) {
          this.requestCount--;
        }
        if (this.requestCount === 0) {
          this.loadPanelService.setLoadPanelVisibility(false);
        }
      }
    }), catchError((error: HttpErrorResponse) => {
      this.loadPanelService.setLoadPanelVisibility(false);
      if (error?.error?.ExceptionMessage) {
        this.notificationService.showErrorMessage(error?.error?.ExceptionMessage);
      }
      return throwError(error);
    }));
  }
}
